import React from "react";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";

/** Small gold rhombus used beside section labels (Map Pool, search tips). */
export default function LobbySectionDiamond({ size = "0.28rem" }) {
    return (
        <Box
            aria-hidden
            sx={{
                width: size,
                height: size,
                transform: "rotate(45deg)",
                background: colors.primary.main,
                boxShadow: `0 0 6px ${alpha(colors.primary.main, 0.4)}`,
                flexShrink: 0,
            }}
        />
    );
}
